module.exports = __webpack_public_path__ + "images/setting_8.png";